import styled from 'styled-components';

export const StyledEventDetailsSummary = styled.div``;
